import React, {Component} from 'react';
import PropTypes from 'prop-types';

class ShortMenu extends Component {

  state = {
    open: false,
    show: false,
    icons: window.generalConfig
  }

  toggleMenu = () => {
    this.setState({ open: !this.state.open })
  }

  scrollListener = (heightToShow) => {
    const top = window.pageYOffset;

    this.setState({
      show: top >= heightToShow,
    })

  }

  checkPageTitle = () => {

    const pageTitle = document.querySelector('.paragraph-seitentitel'),
      siteHeader = document.querySelector('.site-header-wrapper');

    let pageTitleHeight = 0,
      siteHeaderHeight = siteHeader.offsetHeight;

    if (pageTitle != null) {
      pageTitleHeight = pageTitle.offsetHeight;
    }

    return pageTitleHeight + siteHeaderHeight;

  }

  componentDidMount() {

    setTimeout(() => {
      let heightToShow = this.checkPageTitle();

      this.setState({
        show: window.pageYOffset >= heightToShow
      })

      window.addEventListener('scroll', () => this.scrollListener(heightToShow))

    }, 1000)

  }

  render() {
    return (
      <div className="wrapper">
        {this.state.icons &&
          <>
            <div className={`main-icon opener ${this.state.show || this.state.open ? "show" : ""}`} onClick={this.toggleMenu}>
              {this.state.open &&
                <img src="/themes/custom/module_box/src/images/i-icon_X_weiss.svg" alt=""/>
              }
              {!this.state.open &&
                <img src="/themes/custom/module_box/src/images/i-icon_weiss.svg" alt=""/>
              }
            </div>
            {this.state.open &&
              <>
                <div className="overlay" />
                <div className="submenu">
                  {(this.state.icons.fieldKlecks1.entity != null && this.state.icons.fieldLink1 != null) &&
                    <a className="first sub-icon" href={this.state.icons.fieldLink1.url.path}>
                      <img src={this.state.icons.fieldKlecks1.entity.fieldMediaImage.url} alt=""/>
                    </a>
                  }
                  {(this.state.icons.fieldKlecks2.entity != null &&
                      this.state.icons.fieldLink2 != null) &&
                    <a className="second sub-icon"
                       href={this.state.icons.fieldLink2.url.path}>
                      <img
                        src={this.state.icons.fieldKlecks2.entity.fieldMediaImage.url}
                        alt=""/>
                    </a>
                  }
                  {(this.state.icons.fieldKlecks3.entity != null &&
                      this.state.icons.fieldLink3 != null) &&
                    <a className="third sub-icon"
                       href={this.state.icons.fieldLink3.url.path}>
                      <img
                        src={this.state.icons.fieldKlecks3.entity.fieldMediaImage.url}
                        alt=""/>
                    </a>
                  }
                  {(this.state.icons.fieldKlecks4.entity != null &&
                      this.state.icons.fieldLink4 != null) &&
                    <a className="fourth sub-icon"
                       href={this.state.icons.fieldLink4.url.path}>
                      <img
                        src={this.state.icons.fieldKlecks4.entity.fieldMediaImage.url}
                        alt=""/>
                    </a>
                  }
                </div>
              </>
            }
          </>
        }
      </div>
    );
  }
}

ShortMenu.propTypes = {};

export default ShortMenu;
